<template>
  <z-dialog :show="isVisible" :modalSize="modalSize">
    <template v-slot:header>
      <h4 class="modal-title">
        {{ title }}
      </h4>
      <button type="button" class="btn-close" @click="close"></button>
    </template>
    <template v-slot:body>
      <div class="row">
        <div class="col-md-6">
          <z-input
            v-model="name"
            name="name"
            label="Name"
            validate="required"
            @keyup="isSave = true"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-10">
          <z-input
            v-model="url"
            name="url"
            label="Video URL (YouTube or Vimeo)"
            placeholder="valid YouTube or Vimeo link"
            validate="required"
            @keyup="isSave = true"
          />
        </div>
        <div class="col-md-2 custom-duration">
          <z-input
            v-model="duration"
            label="duration"
            type="Number"
            min="0"
            validate="required"
            @change="isSave = true"
            @keyup="isSave = true"
          />
          <span class="custom-minutes">minutes</span>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <z-input
            v-model="start_date"
            name="start_date"
            label="View Start (on a Monday)"
            type="date"
            @change="isSave = true"
          />
        </div>
        <div class="col-md-4">
          <z-input
            v-model="end_date"
            name="end_date"
            label="End (on a Monday)"
            type="date"
            @change="isSave = true"
          />
        </div>
        <div class="col-md-4"></div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <p>
            To ensure your media works in the CorSync app, please set your files
            privacy/visibility setting to Public.
          </p>
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <div class="row custom-footer">
        <div class="col-md-1">
          <span>#{{ id }}</span>
        </div>
        <div class="col-md-7">
          <span v-if="invalidMessage !== ''" class="custom-invalid">{{
            invalidMessage
          }}</span>
        </div>
        <div class="col-md-4">
          <div class="custom-buttons">
            <button
              v-show="isSave"
              class="btn btn-danger me-2"
              @click="performSave()"
            >
              Save
            </button>
            <button type="button" class="btn btn-secondary me-2" @click="close">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </template>
  </z-dialog>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import ZDialog from '@/Components/ZElements/Dialog'
import ZTabs from '@/Components/ZElements/Tabs'
import ZInput from '@/Components/ZElements/Input'
export default {
  name: 'media-dialog',
  components: {
    ZDialog,
    ZTabs,
    ZInput,
  },
  props: {
    show: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      modalSize: 'modal-lg',
      isSave: false,
      validErrors: [],
      invalidMessage: '',
      saveIt: false,
    }
  },
  mounted() {
    this.reset()
  },
  computed: {
    ...mapGetters('dashboardComponents', ['mediaItem']),
    ...mapGetters('organizations', ['examineOrganization']),
    isVisible() {
      return this.show !== null
    },
    title() {
      let _title = 'Edit Media'
      if (this.show) {
        if (this.show.isAdd) {
          _title = 'Add Media'
        } else if (this.mediaItem) {
          _title = `Edit Media`
        }
      }
      return _title
    },
    id() {
      let _id = ''
      if (this.mediaItem) {
        _id = this.mediaItem.id
      }
      return _id
    },
    isAdd() {
      let _is = false
      if (this.show) {
        _is = this.show.isAdd
      }
      return _is
    },
    name: {
      get() {
        let _data = null
        if (this.mediaItem) {
          _data = this.mediaItem.name
        }
        return _data
      },
      set(value) {
        this.setMediaData({
          name: 'name',
          value: value,
        })
      },
    },
    url: {
      get() {
        let _data = null
        if (this.mediaItem) {
          _data = this.mediaItem.url
        }
        return _data
      },
      set(value) {
        this.setMediaData({
          name: 'url',
          value: value,
        })
      },
    },
    duration: {
      get() {
        let _data = 0
        if (this.mediaItem) {
          _data = this.mediaItem.duration
        }
        return _data
      },
      set(value) {
        this.setMediaData({
          name: 'duration',
          value: parseInt(value),
        })
      },
    },
    priority: {
      get() {
        let _data = null
        if (this.mediaItem) {
          _data = this.mediaItem.priority
        }
        return _data
      },
      set(value) {
        this.setMediaData({
          name: 'priority',
          value: parseInt(value),
        })
      },
    },
    start_date: {
      get() {
        let _data = null
        if (this.mediaItem) {
          _data = moment
            .utc(new Date(this.mediaItem.start_date))
            .format('YYYY-MM-DD')
        }
        return _data
      },
      set(value) {
        let _start = moment.utc(new Date(value)).startOf('week').add(1, 'days')
        console.log('New Start Date', {
          moment: _start,
          formatted: _start.format('YYYY-MM-DD') + ' 00:00:00',
        })
        this.setMediaData({
          name: 'start_date',
          value: _start.format('YYYY-MM-DD') + ' 00:00:00',
        })
        window.app.$forceUpdate()
      },
    },
    end_date: {
      get() {
        let _data = null
        if (this.mediaItem) {
          _data = moment
            .utc(new Date(this.mediaItem.end_date))
            .format('YYYY-MM-DD')
        }
        return _data
      },
      set(value) {
        let _end = moment.utc(new Date(value)).startOf('week').add(1, 'days')
        console.log('New End Date', {
          moment: _end,
          formatted: _end.format('YYYY-MM-DD') + ' 00:00:00',
        })
        this.setMediaData({
          name: 'end_date',
          value: _end.format('YYYY-MM-DD') + ' 00:00:00',
        })
        window.app.$forceUpdate()
      },
    },
  },
  methods: {
    ...mapActions('dashboardComponents', ['setMediaData', 'saveMedia']),
    reset() {
      this.validErrors = []
      this.isSave = false
      this.invalidMessage = ''
      this.saveIt = false
    },
    validateUrl() {
      let valid = false
      let url = this.mediaItem.url
      console.log('validating URL', url)
      if (url !== '') {
        if (url.indexOf('http://') === 0 || url.indexOf('https://') === 0) {
          let str = url.substr(url.indexOf('://') + '://'.length)
          valid =
            str.indexOf('youtube.') === 0 ||
            str.indexOf('vimeo.') === 0 ||
            str.indexOf('youtu.be') === 0 ||
            str.indexOf('drive.google') === 0
        }
      }
      return valid
    },
    validate() {
      let valid = true
      this.validErrors = []
      this.invalidMessage = ''
      if (this.mediaItem.name === '') {
        valid = false
        this.validErrors.push('name')
      }
      if (this.mediaItem.url === '') {
        valid = false
        this.validErrors.push('url')
      }
      if (this.mediaItem.duration === null) {
        valid = false
        this.validErrors.push('duration')
      }
      if (this.mediaItem.duration <= 0) {
        valid = false
        this.validErrors.push('duration')
      }
      if (valid) {
        if (!this.validateUrl()) {
          valid = false
          this.validErrors.push('invalid or missing URL')
        }
      }
      return valid
    },
    async performSave() {
      let success = false
      let valid = this.validate()
      if (valid) {
        // save the Media
        console.log('Saving the Media Link Info', this.mediaItem)
        await this.saveMedia(this.mediaItem)
        success = true
        this.isSave = false
        this.reset()
        this.$emit('saved')
      } else {
        success = false
        this.invalidMessage = 'missing ' + this.validErrors.join(', ')
      }
      return success
    },
    close() {
      this.reset()
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-header {
  width: 100%;
}
.custom-body {
  max-height: 650px;
  overflow-x: hidden;
  overflow-y: scroll;
}
.custom-footer {
  width: 100%;
  text-align: left;
}
.custom-invalid {
  color: red;
  font-weight: 500;
}
.custom-buttons {
  position: relative;
  float: right;
}
.custom-duration {
  position: relative;
}
.custom-minutes {
  position: absolute;
  bottom: -8px;
  font-size: 0.8em;
}
</style>
